"use client";

import { Row } from "@tanstack/react-table";
import { Eye, MoreHorizontal } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import type { IPropagationCampaign } from "src/@types/campaign-propagation";

interface DataTableRowActionsProps {
  row: Row<IPropagationCampaign>;
}

export function DataTableRowActions({
  row,
}: DataTableRowActionsProps) {
  const navigate = useNavigate();
  const campaign = row.original;

  const handleViewDetails = () => {
    navigate(`/planejamento-comercial/auditoria-propagacao/${campaign.campaign_type}/${campaign.campaign_code}`);
  };


  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost_none"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
        >
          <MoreHorizontal />
          <span className="sr-only">Abrir Menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[180px]">
        <DropdownMenuItem onClick={handleViewDetails}>
          <Eye className="mr-2 h-4 w-4" />
          Ver Detalhes
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
